module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"files":"Files","attachFiles":"Attach Files","fileSizeError":"Total attachments size cannot exceed 20Mb."},"es":{"files":"Archivos","attachFiles":"Adjuntar archivos","fileSizeError":"El tamaño total de los archivos adjuntos no puede execeder los 20Mb."}}')
  delete Component.options._Ctor
}
